import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
// Using appropriate hair-related images from Unsplash

const Services = () => {
  const services = [
    {
      icon: 'fas fa-female',
      title: 'Premium Wigs',
      description: 'High-quality human hair and synthetic wigs in various styles, lengths, and colors.',
      image: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-cut',
      title: 'Hair Weaves',
      description: 'Beautiful weave bundles from Brazilian, Peruvian, and Malaysian hair collections.',
      image: 'https://images.unsplash.com/photo-1560869713-7d0954f92b8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-tools',
      title: 'Wig Making Supplies',
      description: 'Complete wig-making kits including caps, needles, thread, and styling tools.',
      image: 'https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-palette',
      title: 'Hair Styling',
      description: 'Professional hair styling services and custom wig installations.',
      image: 'https://images.unsplash.com/photo-1562322140-8baeececf3df?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-star',
      title: 'Hair Care Products',
      description: 'Premium shampoos, conditioners, and treatments for maintaining healthy hair.',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Wig Making Classes',
      description: 'Learn professional wig-making techniques with our expert instructors.',
      image: 'https://images.unsplash.com/photo-1559599101-f09722fb4948?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Hair Collection</h2>
          <p>Premium hair products and services to help you achieve your perfect look</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;